import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { businessInfo } from '../mock';

export const ContactSection = ({ onContactClick }) => {
  return (
    <section id="contact" className="py-20 bg-[#EFEBE9]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto">
            Contact us today for a free consultation. Our trademark experts are ready to help protect your brand.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <Card className="border-2 border-[#D7CCC8] bg-white shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl font-bold text-[#3E2723]">
                Contact Information
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#3E2723] rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-[#3E2723] mb-1">Office Address</h3>
                  <p className="text-[#8D6E63]">{businessInfo.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#3E2723] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-[#3E2723] mb-1">Phone Number</h3>
                  <a
                    href={`tel:${businessInfo.phone}`}
                    className="text-[#8D6E63] hover:text-[#3E2723] transition-colors"
                  >
                    {businessInfo.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#3E2723] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-[#3E2723] mb-1">Email Address</h3>
                  <a
                    href={`mailto:${businessInfo.email}`}
                    className="text-[#8D6E63] hover:text-[#3E2723] transition-colors break-all"
                  >
                    {businessInfo.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#3E2723] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-[#3E2723] mb-1">Business Hours</h3>
                  <p className="text-[#8D6E63]">Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p className="text-[#8D6E63]">Saturday: 10:00 AM - 4:00 PM</p>
                  <p className="text-[#8D6E63]">Sunday: Closed</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2 border-[#D7CCC8] bg-white shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl font-bold text-[#3E2723]">
                Request a Free Consultation
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-[#8D6E63] mb-6 leading-relaxed">
                Take the first step in protecting your brand. Click below to fill out our quick consultation request form, and one of our trademark experts will contact you within 24 hours.
              </p>
              
              <Button
                onClick={onContactClick}
                className="w-full bg-[#3E2723] hover:bg-[#5D4037] text-white py-6 text-lg font-semibold transition-all duration-300 hover:shadow-xl mb-6"
              >
                Request Free Consultation
              </Button>

              <div className="bg-[#EFEBE9] rounded-lg p-6 border-2 border-[#D7CCC8]">
                <h4 className="font-bold text-[#3E2723] mb-3">What to Expect:</h4>
                <ul className="space-y-2 text-[#8D6E63] text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-[#3E2723] font-bold">✓</span>
                    <span>Free initial trademark search and consultation</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#3E2723] font-bold">✓</span>
                    <span>Assessment of your trademark's registrability</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#3E2723] font-bold">✓</span>
                    <span>Personalized recommendations for your brand</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#3E2723] font-bold">✓</span>
                    <span>No obligation - completely risk-free</span>
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
